export default "__VITE_ASSET__Bw8DLULQ__"